import { api } from "../api";
import type {
  ReportTemplate,
  ReportTemplateCreate,
  ReportTemplateUpdate,
} from "../../types/domain";

export const reportTemplateService = {
  getAll: () => api.get<ReportTemplate[]>("/report-templates"),

  getById: (id: string) => api.get<ReportTemplate>(`/report-templates/${id}`),

  create: (data: ReportTemplateCreate) =>
    api.post<ReportTemplate>("/report-templates", data),

  update: (id: string, data: ReportTemplateUpdate) =>
    api.patch<ReportTemplate>(`/report-templates/${id}`, data),

  delete: (id: string) => api.delete<void>(`/report-templates/${id}`),
};
